import {
  LIST_FILTER_DATA_UPDATE,
  LIST_FILTER_DATA_SET,
  LIST_FILTER_STATUS_SET,
  LIST_FILTER_CLEAR,
  LIST_FILTER_SOURCE_CLEAR,
  LIST_FILTER_INITIAL_STATE_SET,
  LIST_FILTER_INITIAL_STATE_UPDATE,
  LIST_FILTER_PRISTINE_SET,
  LIST_FILTER_SET_APPLIED_STATUS
} from '#action/types';
import { webPortalApi } from '#config/web-portal-api';
import { snackBarError } from '#action/fetch';
import { transformOptions } from '#component/general/list-filter/helper';
import { getRequestOptions } from '#helper';

export const updateFilterData = (value, name, id) => {
  const v = typeof value === 'string' ? value.trim() : value;

  return ({
    type: LIST_FILTER_DATA_UPDATE,
    payload: { value: v, name, id }
  });
};

export const setFilterData = data => ({
  type: LIST_FILTER_DATA_SET,
  payload: data
});

export const setFilterStatus = status => ({
  type: LIST_FILTER_STATUS_SET,
  payload: status
});

export const clearSourceFilterData = id => ({
  type: LIST_FILTER_SOURCE_CLEAR,
  payload: { id }
});

export const clearFilter = () => ({
  type: LIST_FILTER_CLEAR
});

export const setInitialState = state => ({
  type: LIST_FILTER_INITIAL_STATE_SET,
  payload: state
});

const updateInitialStateAction = (newState, name) => ({
  type: LIST_FILTER_INITIAL_STATE_UPDATE,
  payload: { newState, name }
});

export const setFilterPristine = isPristine => ({
  type: LIST_FILTER_PRISTINE_SET,
  payload: isPristine
});

export const setFilterAppliedStatus = appliedStatus => ({
  type: LIST_FILTER_SET_APPLIED_STATUS,
  payload: appliedStatus
});

let abortController = new AbortController();

export const fetchProjectWarehouses = filteredProjects =>
  async (dispatch, getState) => {
    try {
      abortController.abort();
      const searchParams = new URLSearchParams({
        limit: 50,
        order: 'asc',
        orderBy: 'label',
        offset: 0,
        pagination: 1
      });

      const warehouse = getState().listFilter?.warehouse;
      const warehouseValue = warehouse?.warehouse?.value;

      if (!warehouseValue?.length) {
        return;
      }

      if (filteredProjects) {
        const ids = filteredProjects.map(v => v.data.id).join(',');

        if (ids) {
          searchParams.set('project', ids);
        }
      }

      abortController = new AbortController();
      const { signal } = abortController;

      const warehousesUrl = webPortalApi.buildApiUrl(`warehouse?${searchParams.toString()}`);
      const warehousesRes = await fetch(warehousesUrl, { ...getRequestOptions(), signal });
      const contentType = warehousesRes.headers.get('content-type');

      if (!contentType || !contentType.includes('application/json')) {
        throw new TypeError('Response is not json');
      }

      const res = await warehousesRes.json();

      if (!warehousesRes.ok) {
        throw new Error(res);
      }

      const allowedWarehousesTransformed = transformOptions(res);

      const allowedWarehouses = warehouseValue.filter(selectedWarehouse =>
        allowedWarehousesTransformed.some(allowedWH =>
          allowedWH.data.id === selectedWarehouse.data.id));

      dispatch(updateFilterData(allowedWarehouses, 'warehouse', 'warehouse'));
    } catch (e) {
      if (e.name === 'AbortError') return;
      console.error(e);
      dispatch(snackBarError({ message: 'Error in request' }));
    }
  };

export const resetProjectSubprojects = () => async (dispatch, getState) => {
  const currentProjectFilter = getState().listFilter?.project ?? {};
  dispatch(updateFilterData('', 'subproject', 'project'));
  dispatch(updateInitialStateAction({ ...currentProjectFilter, subproject: '' }, 'project'));
};

export const updateInitialState = (newState, name) => (dispatch, getState) => {
  const state = getState();
  const filter = state.listFilter?.[name];

  dispatch(updateInitialStateAction(newState || filter, name));
};
